<template>
  <div class="container">
    <!-- <p class="titulo-lista-carrito">Total Facturado: ${{ dotsCadaTres(parseFloat(this.totalFacturadoCarrito).toFixed(2).replace(/\.00$/, '')) }}</p>
    <p class="titulo-lista-carrito">Cantidad de productos vendidos: {{ this.cantidadProductosVendidos}}</p> -->
    <!-- <button
      class="boton_exportar"
      @click="exportData"
    >
      Exportar a Excel
    </button> -->
    <table class="tabla-stocks">
      <thead>
        <!-- <th class="nofuente">IMAGEN</th> -->
        <th>Fecha</th>
        <th>Monto</th>
        <th>Persona</th>
        <th>Estado</th>

        <!-- <th>Condición</th> -->
        <!-- <th class="nofuente gradient_2">Entrega</th> -->
      </thead>
      <tbody>
        <VentasListaCarritoNoEntregadasItem
          v-for="venta in ventas"
          :venta="venta"
          :key="venta.venta_id"
        ></VentasListaCarritoNoEntregadasItem>
      </tbody>
    </table>
  </div>
</template>

<script>
import VentasListaCarritoNoEntregadasItem from '../components/VentasListaCarritoNoEntregadasItem.vue'
import ventasService from '../services/ventas'
// import productosService from '../services/productos'
const XLSX = require('xlsx')
export default {
  name: 'VentasListaCarritoNoEntregadas',
  components: {
    VentasListaCarritoNoEntregadasItem
  },
  data: function () {
    return {
      ventas: [],
      productos: [],
      archivo: [],
      cantidadProductosVendidos: null,
      totalFacturadoCarrito: null
    }
  },
  methods: {
    dotsCadaTres (dni) {
      const number = dni.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1.')
      return number
    },
    exportData () {
      console.log(this.pagos)
      const data = this.archivo
      // const data = [{ foo: 'foo' }, { bar: 'bar' }]
      // const fileName = 'Listado_de_Pagos'
      // const exportType = 'csv'
      // exportFromJSON({ data, fileName, exportType })
      // exportFromJSON({ data, exportType })
      const workSheet = XLSX.utils.json_to_sheet(data)
      const workBook = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(workBook, workSheet, 'Ventas Carrito')
      XLSX.writeFile(workBook, 'Ventas_Carrito.xlsx')
    },
    exportarExcel (data) {
      this.archivo = []
      for (var j = 0; j < data.length; j++) {
        const obj = {}
        obj.Producto = data[j].nombre
        obj.Cantidad_Productos_Vendidos = data[j].cantidad
        obj.Total_Facturado = data[j].precio_total
        obj.Cantidad_Productos_Con_Descuento = data[j].cantidad_socio
        obj.Facturado_Productos_Con_Descuento = data[j].facturado_socio
        obj.Cantidad_Productos_Sin_Descuento = data[j].cantidad_no_socio
        obj.Facturado_Productos_Sin_Descuento = data[j].facturado_no_socio
        this.archivo.push(obj)
      }
    }
  },
  mounted: function () {
    ventasService
      .traerProductosVendidosNoEntregados()
      .then(respuesta => {
        // this.cargando = false
        this.cantidadProductosVendidos = respuesta.cantidadProductosVendidos
        this.totalFacturadoCarrito = respuesta.totalFacturadoCarrito
        this.ventas = respuesta.data
        console.log('Listado de ventas: ', respuesta)
        this.exportarExcel(respuesta)
      })
    // productosService
    //   .traerProductosTodos()
    //   .then(respuesta => {
    //     // this.cargando = false
    //     this.productos = respuesta
    //     console.log('Todos los productos', respuesta)
    //   })
  }
}
</script>

<style>

</style>
